import React from 'react';
import { Row, Col } from 'react-bootstrap';
import TitleLight from '../../components/Text/TitleLight';
import TitleBold from '../../components/Text/TitleBold';
import i18n from '../../locales';
import MainStyles from '../../styles/MainStyles';
import './Login.css'
import WhiteButton from '../../components/Buttons/WhiteButton';
import BannerHeader from '../../components/Headers/BannerHeader';

const PageLogin = (props) => {
  return (
    <div>
      <BannerHeader/>
      <Row className='login-container welcome-txt-container '>
        <Col>
          <Row>
            <Col md={{ span: 8, offset: 1 }}>
              <TitleLight
                text={i18n.t('login.title')}
                size={'big'}
              />
              <TitleBold
                text={i18n.t('login.title_bold')}
                size={'big'}
              />
            </Col>
          </Row>
          <Row>
            <Col md={{ span: 8, offset: 2 }} style={{paddingTop: '12px'}}>
              <TitleLight
                text={i18n.t('login.desc')}
                size={'little'}
              />
            </Col>
          </Row>
        </Col>
      </Row>
      <Row className='login-container' style={{ ...MainStyles.containerGradient }}>
        <Col>
          <Row>
            <Col md={{ span: 7, offset: 1 }}>
              <TitleLight
                text={i18n.t('login.vw_id_action')}
                size={'medium'}
                color={MainStyles.colors.white}
              />
            </Col>
            <Col md={{ span: 3 }}>
              <WhiteButton
                text={i18n.t('general.next')}
                isRounded={true}
                onClick={() => {
                  props.history.push('/login-redirect')
                }}
              />
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
  )
}

export default PageLogin
